import { UtilsClass } from "../components/UtilityHelpers/UtilsClass";

export const useUtils = () => {
    return new UtilsClass;
}